module.exports = __webpack_public_path__ + "static/media/logo-2.0e8eb403.svg";